import { useEffect, useState } from 'react';

export const useWebSocket = (url: string) => {
  const [webSocket, setWebSocket] = useState<WebSocket | null>(null);

  useEffect(() => {
    const socket = new WebSocket(url);
    setWebSocket(socket);

    return () => {
      socket.close();
    };
  }, [url]);

  return webSocket;
};
